export default "__VITE_ASSET__B95xlZPL__"